// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MzAoofkarg8R1nCO7la1 {\n\twidth: 220px;\n}\n\n.soEswG4WKoF4FLco5hgv {\n\twidth: 100%;\n}\n", "",{"version":3,"sources":["webpack://./client/src/screens/general/HomeScreen/dashboards/PayablesAgingDashboard.module.css"],"names":[],"mappings":"AAAA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;AACZ","sourcesContent":[".widerSelect {\n\twidth: 220px;\n}\n\n.table {\n\twidth: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"widerSelect": "MzAoofkarg8R1nCO7la1",
	"table": "soEswG4WKoF4FLco5hgv"
};
export default ___CSS_LOADER_EXPORT___;
